module.exports = __webpack_public_path__ + "img/Expert5Guy.303dbeb2.png";